import { render, staticRenderFns } from "./ShouhuoAddr.vue?vue&type=template&id=74bd0d3c&scoped=true&"
import script from "./ShouhuoAddr.vue?vue&type=script&lang=js&"
export * from "./ShouhuoAddr.vue?vue&type=script&lang=js&"
import style0 from "./ShouhuoAddr.vue?vue&type=style&index=0&id=74bd0d3c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bd0d3c",
  null
  
)

export default component.exports